import request from '@/utils/request'

export default {
  getUserAccountList() {
    return request.post('/reference-data/getUserAccounts', {})
  },
  getCurrencyList(qry) {
    return request.post('/reference-data/getCurrencies', qry)
  },
  getCountryList(qry) {
    return request.post('/reference-data/getCountries', qry)
  },

  getCountryCurrencyList() {
    return request.get('/reference-data/getCountryCurrencies')
  },

  getReferenceDataV2() {
    return request.get('/reference-data/getReferenceDataV2')
  },
}
